import { FileEntity } from 'api/types/entity';
import { FormFM1ClientType } from 'api/types/params';
import {
  TypedForm,
  ObjectSchema,
  object,
  array,
  selectSchema,
  number,
} from 'libs/form';
import { localFileScheme } from 'modules/client/common/helpers';
import { SelectType } from 'types/selectType';

export interface LocalFileEntity extends Omit<FileEntity, 'id'> {
  id?: string;
  file?: File;
}

export enum FormFM1Currency {
  USD = 'USD',
}

export interface FormFM1FormType {
  thresholdValue: number;
  clients: SelectType<FormFM1ClientType>[];
  currency: SelectType<FormFM1Currency>;
  usdKzt: number;
  cnyKzt: number;
  eurKzt: number;
  rubKzt: number;
  aedKzt: number;
  files: LocalFileEntity[];
}
export const MAX_FILES = 1;
export const MAX_FLOATING_POINTS = 4;
export const MIN_RATE = 1;
export const MAX_RATE = 3000 * 10000;

export const getSchema = (): ObjectSchema<FormFM1FormType> =>
  object({
    thresholdValue: number().required(),
    currency: selectSchema(Object.values(FormFM1Currency))
      .required()
      .default(null),
    clients: array()
      .of(
        selectSchema(Object.values(FormFM1ClientType)).required().default(null)
      )
      .min(1)
      .required(),
    usdKzt: number().required().min(MIN_RATE).max(MAX_RATE),
    cnyKzt: number().required().min(MIN_RATE).max(MAX_RATE),
    eurKzt: number().required().min(MIN_RATE).max(MAX_RATE),
    rubKzt: number().required().min(MIN_RATE).max(MAX_RATE),
    aedKzt: number().required().min(MIN_RATE).max(MAX_RATE),
    files: array()
      .of(localFileScheme.required())
      .required()
      .min(1)
      .max(MAX_FILES),
  });

export const { Field, Form, useFormContext, Submit } =
  TypedForm<FormFM1FormType>();
